import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reveal — scroll-triggered fade + rise animation wrapper.
 * Respects prefers-reduced-motion automatically via framer-motion.
 *
 * Props:
 *  - as: element/component to render (default 'div')
 *  - delay: animation delay in seconds
 *  - y: initial vertical offset in px (default 24)
 *  - once: only animate the first time it enters view (default true)
 *  - amount: portion visible before triggering (default 0.2)
 */
const Reveal = ({
  children,
  as = 'div',
  delay = 0,
  y = 24,
  once = true,
  amount = 0.2,
  className = '',
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
